var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "tagList",
    staticClass: "tagList",
    class: _vm.tagOptionPopListViewBln ? 'open' : null
  }, [_c('ul', _vm._l(_vm.tags, function (tag) {
    return _c('li', {
      style: {
        '--bg-color': tag.color
      }
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.clickHandler(tag);
        }
      }
    }, [_c('i', {
      staticClass: "icon"
    }), _c('span', [_vm._v(_vm._s(tag.name))])])]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }